<template>
  <v-container>
    <div class="text-center">
      <SectionTitle class="d-inline-block">Um sistema completo para você oferecer</SectionTitle>
      <p class="section-subtitle mt-4">
        Você leva para restaurantes, lanchonetes, pizzarias e deliveries um produto pronto,
        que automatiza os pedidos e ajuda o estabelecimento a vender mais.
      </p>
    </div>

    <v-row class="mt-8">
      <v-col
        v-for="(item, i) in recursos"
        :key="i"
        cols="6"
        md="3"
      >
        <div class="feature">
          <v-icon size="26" color="error">{{ item.icon }}</v-icon>
          <span class="feature__title">{{ item.title }}</span>
        </div>
      </v-col>
    </v-row>

    <div class="closing mt-12">
      <h3 class="closing__title">Vamos crescer juntos</h3>
      <p class="closing__desc">Comece em três passos:</p>

      <ol class="closing__steps">
        <li v-for="(step, i) in passos" :key="i">
          <span class="closing__num">{{ i + 1 }}</span>
          <span>{{ step }}</span>
        </li>
      </ol>

      <CtaButton>Quero ser revenda</CtaButton>
    </div>
  </v-container>
</template>

<script>
  import SectionTitle from '@/components/SectionTitle.vue';
  import CtaButton from '@/components/CtaButton.vue';

  export default {
    name: 'RevendaProdutoSection',

    components: {
      SectionTitle,
      CtaButton,
    },

    data: () => ({
      recursos: [
        { icon: 'mdi-qrcode', title: 'Cardápio digital e pedidos por QR Code' },
        { icon: 'mdi-printer-pos', title: 'Impressão automática na cozinha' },
        { icon: 'mdi-robot-outline', title: 'Robô de atendimento no WhatsApp' },
        { icon: 'mdi-tablet', title: 'Autoatendimento no tablet de mesa' },
        { icon: 'mdi-cellphone', title: 'PDV e app do garçom' },
        { icon: 'mdi-moped-outline', title: 'Integração com iFood' },
        { icon: 'mdi-cash-check', title: 'Pix automatizado' },
        { icon: 'mdi-file-document-outline', title: 'Emissão de nota fiscal' },
      ],
      passos: [
        'Fale com o time e entre para o programa de revenda',
        'Apresente o ZaperMenu aos estabelecimentos da sua região',
        'Receba até 80% da 1ª mensalidade e a comissão recorrente',
      ],
    }),
  };
</script>

<style scoped lang="scss">
  .section-subtitle {
    font-size: 17px;
    line-height: 1.7;
    color: var(--text-muted);
    max-width: 640px;
    margin: 0 auto;

    @media (max-width: 780px) {
      font-size: 15px;
    }
  }

  .feature {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
    height: 100%;
    padding: 20px 18px;
    border-radius: 14px;
    background: var(--card-bg);
    border: 1px solid var(--card-border);

    &__title {
      font-size: 15px;
      font-weight: 600;
      line-height: 1.4;
      color: var(--text-primary);

      @media (max-width: 600px) {
        font-size: 13px;
      }
    }
  }

  /* ── Fechamento ── */
  .closing {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    padding: 44px 28px;
    border-radius: 22px;
    border: 1px solid rgba(244, 6, 18, 0.35);
    background:
      radial-gradient(ellipse at top, rgba(244, 6, 18, 0.12) 0%, transparent 65%),
      var(--card-bg);

    @media (max-width: 600px) {
      padding: 32px 18px;
    }

    &__title {
      font-size: 30px;
      font-weight: 700;
      margin: 0;
      color: var(--text-primary);

      @media (max-width: 600px) {
        font-size: 24px;
      }
    }

    &__desc {
      font-size: 16px;
      color: var(--text-muted);
      margin: 8px 0 0;
    }

    &__steps {
      list-style: none;
      padding: 0;
      margin: 22px 0 8px;
      display: flex;
      flex-direction: column;
      gap: 12px;
      text-align: left;

      li {
        display: flex;
        align-items: center;
        gap: 12px;
        font-size: 15px;
        line-height: 1.5;
        color: var(--text-secondary);
      }
    }

    &__num {
      flex-shrink: 0;
      width: 28px;
      height: 28px;
      border-radius: 50%;
      background: linear-gradient(135deg, #f40612 0%, #ff6b35 100%);
      color: #fff;
      font-size: 13px;
      font-weight: 700;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
</style>
